import React from 'react';
import PureComponent from '../pure';
import PropTypes from 'prop-types';

import SweetSpotResultContainer from './SweetSpotResultContainer';

import sAction from 'sAction';

class SweetSpot extends PureComponent {
    constructor() {
        super();
        this.state = {
            resultArrowIndex: -1,
        };

        this.searchInterval = null;
        this.max = 0;
        this.input = React.createRef();
        this.keyboardListener = (event) => this.keyUp(event);
    }

    keyUp(ev) {
        const keyCode = ev.keyCode;
        if (keyCode === 13) {
            if (this.state.resultArrowIndex !== -1) {
                sAction.sweetSpotAction({item: null, index: this.state.resultArrowIndex});
                return;
            }

            this.search();
        } else if (keyCode === 27) {
            sAction.hideSweetSpot();
        } else if (keyCode === 40 || keyCode === 38) {
            this.changeArrowIndex(keyCode);
        } else if (keyCode !== 9 && keyCode !== 37 && keyCode !== 39) {
            this.waitForSearch();
        }
    }

    waitForSearch() {
        if (this.searchInterval !== null) {
            clearTimeout(this.searchInterval);
        }
        const self = this;
        this.searchInterval = setTimeout(() => {
            self.search();
        }, 300);
    }

    search() {
        const value = this.input.current.value;
        const module = this.props.data.get('module');
        if (value !== '') {
            this.setState({resultArrowIndex: -1});
            sAction.sweetSpotSearch(value, module);
        }
    }

    changeArrowIndex(keyCode) {
        let resultArrowIndex = this.state.resultArrowIndex;
        if (keyCode === 40) {
            resultArrowIndex += 1;
        } else if (keyCode === 38) {
            resultArrowIndex -=1;
        }

        if (resultArrowIndex <= -1) {
            resultArrowIndex = this.max - 1;
        } else if (resultArrowIndex >= this.max) {
            resultArrowIndex = 0;
        }
        this.setState({resultArrowIndex: resultArrowIndex});
    }

    componentDidMount() {
        document.addEventListener('keyup', this.keyboardListener, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.keyboardListener, false);
        clearTimeout(this.searchInterval);
    }

    render() {
        const data = this.props.data.get('data');
        const resComp = [];

        // rozdělení dat na kategorie
        const dataCat = {actions: [], records: []};
        if (data) {
            data.forEach((item) => {
                if (item.record) {
                    dataCat.records.push(item);
                } else {
                    dataCat.actions.push(item);
                }
            });
        }

        let indexOffset = 0;
        dataCat.forEachObject((value, key) => {
            if (value.length) {
                resComp.push(<SweetSpotResultContainer
                    key={key}
                    title={key}
                    data={value}
                    arrowIndex={this.state.resultArrowIndex - indexOffset}
                />);
                indexOffset += value.length;
            }
        });

        this.max = indexOffset;
        return (
            <React.Fragment>
                <div className="sweetSpotContainer">
                    <div className="sweetSpotInputContainer">
                        <input
                            type="text"
                            className="sweetspot-searchinput"
                            name="sweetspot-searchinput"
                            ref={this.input}
                            autoFocus={true}
                            autoComplete="off"
                        />
                    </div>
                    {resComp}
                </div>
            </React.Fragment>
        );
    }
}

SweetSpot.propTypes = {
    data: PropTypes.object,
};

export default SweetSpot;
